import { render, staticRenderFns } from "./change-gateway-status.vue?vue&type=template&id=b4ede082"
import script from "./change-gateway-status.vue?vue&type=script&lang=js"
export * from "./change-gateway-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports